import { QuizValue } from './quiz.value';

export class QuizValueDto {
    name: string;
    questionIds?: string[];

    constructor(data: QuizValue) {
        this.name = data.name;

        if (data.questionIds) {
            this.questionIds = data.questionIds;
        }
    }
}
